import axios from 'axios'

// Em produção o SPA chama https://api-ev.theconect.com.br/api (proxy -> VM101:8009).
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://api-ev.theconect.com.br/api',
})

// Anexa o JWT salvo, sem sobrescrever um Authorization explícito (usado no "Ver como").
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token && !(config.headers && config.headers.Authorization)) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default api
